import { push }         from "connected-react-router";
import React, { FC }    from "react";
import { useDispatch }  from "react-redux";
import { Button, Icon } from "semantic-ui-react";

interface Props {
  path: string;
}

const BackHistoryButton: FC<Props> = (props: Props) => {
  const {path} = props;
  const dispatch = useDispatch();

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => dispatch(push(path)) }
      >
        <Icon name="arrow left"/>
        前の画面へ戻る
      </Button>
    </>
  );
};

export default BackHistoryButton;
